var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.reqmts),function(rqm,index){return _c('AuditRequirement',{key:index,attrs:{"requirement":rqm,"number":index,"audit":_vm.audit,"isOpen":_vm.isOpen},on:{"clicked":_vm.setOpen}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }